/**
 * Asserts is the condition is false. Throws the message as an error.
 * @param {boolean} condition 
 * @param {string} msg 
 */
export function isTrue(condition, msg = "Assertion Failed")
{
    if (condition)
    {
        return condition;
    }
    throw new Error(msg);  
}

/**
 * Assertion that always fails. Throws the message as an error.
 * @param {string} msg 
 */
export function fail(msg = "Assertion Failed")
{
    throw new Error(msg);    
}